export interface IPagingRequest {
    totalItems: number;
    currentPage: number;
    itemsPerPage: number;
    maxNumberPageLinks: number;
}

export interface IPagingData {
    pageNumbers: number[];
    lastPageNumber: number;
}

export class PagingCalculator {

    public getPageNumbers(pagingData: IPagingRequest): IPagingData {

        const pageNumbers: number[] = [];

        // Ensure that we have an even number of page links...
        const maxNumberPageLinks = pagingData.maxNumberPageLinks % 2 ? pagingData.maxNumberPageLinks + 1 : pagingData.maxNumberPageLinks;

        const totalNumberOfPages = this.getNumberOfPages(pagingData);
        const numberOfPages = totalNumberOfPages <= maxNumberPageLinks ? totalNumberOfPages : maxNumberPageLinks;

        const halfWay = Math.abs(maxNumberPageLinks / 2);

        // If less than or equal to max page numbers, then just spit them out.
        let startNumber = 1;

        if (numberOfPages === maxNumberPageLinks) {
          const totalNumberOfItemsOnRight = totalNumberOfPages - pagingData.currentPage;
          let numberOfItemsOnLeft = halfWay;

          if (pagingData.currentPage <= halfWay) {
            startNumber = 1;
          } else if (totalNumberOfItemsOnRight < halfWay) {
            numberOfItemsOnLeft = maxNumberPageLinks - totalNumberOfItemsOnRight;
            startNumber = pagingData.currentPage - numberOfItemsOnLeft;
          } else {
            startNumber = pagingData.currentPage - halfWay;
          }
        }

        startNumber = startNumber > 0 ? startNumber : 1;
        const lastPageNumber = (startNumber + numberOfPages) <= totalNumberOfPages ? (startNumber + numberOfPages) : totalNumberOfPages;

        for (let i = startNumber; i <= lastPageNumber; i++) {
          pageNumbers.push(i);
        }

        return {
          lastPageNumber,
          pageNumbers,
        };
      }

      private getNumberOfPages(pagingData: IPagingRequest) {
        const totalRows = (pagingData.totalItems) ? pagingData.totalItems : 0;
        return (pagingData.itemsPerPage) ? Math.ceil(totalRows / pagingData.itemsPerPage) : 0;
      }
}